import { render, staticRenderFns } from "./404not_fund.vue?vue&type=template&id=31e67d5f&"
import script from "./404not_fund.vue?vue&type=script&lang=js&"
export * from "./404not_fund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports